import ScrollReveal from "../../../components/feature/ScrollReveal";

const inquiryTypes = [
  {
    icon: "ri-calendar-check-line",
    title: "予約相談",
    desc: "希望日・時間帯・人数・目的をお聞かせください。最適なプランをご提案します。",
  },
  {
    icon: "ri-money-cny-circle-line",
    title: "料金・プランについて",
    desc: "コース内容、オプション、割引情報など、料金に関するご質問を承ります。",
  },
  {
    icon: "ri-gift-line",
    title: "ギフトチケットについて",
    desc: "ギフト包装、有効期限、贈り方の方法など、ギフトに関するお問い合わせです。",
  },
  {
    icon: "ri-user-smile-line",
    title: "初めての方への質問",
    desc: "服装、持ち物、当日の流れ、安全面など、初めての方のご不安を解消します。",
  },
  {
    icon: "ri-refresh-line",
    title: "キャンセル・変更",
    desc: "日程変更、キャンセル手続き、ポリシーに関するお問い合わせです。",
  },
  {
    icon: "ri-question-line",
    title: "その他",
    desc: "上記に該当しないご質問・ご相談はこちらからお送りください。",
  },
];

export default function InquiryTypesSection() {
  return (
    <section className="py-16 md:py-20 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-10">
              <p className="section-label mb-3">INQUIRY TYPE</p>
              <h2 className="section-title">お問い合わせ種別を選択</h2>
              <p className="mt-3 text-sm text-airdoa-gray leading-relaxed max-w-2xl mx-auto">
                以下からお問い合わせの種別をお選びいただき、フォームよりご送信ください。
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {inquiryTypes.map((type, idx) => (
              <ScrollReveal key={type.title} direction="up" delay={idx * 80}>
                <div className="bg-white rounded-lg p-5 md:p-6 border border-airdoa-gray-light/30 h-full transition-all duration-300 hover:border-airdoa-gold/50">
                  <div className="w-10 h-10 flex items-center justify-center text-airdoa-gold mb-3">
                    <i className={`${type.icon} text-xl`} />
                  </div>
                  <h3 className="text-sm font-serif font-semibold text-airdoa-navy">
                    {type.title}
                  </h3>
                  <p className="mt-2 text-xs text-airdoa-gray leading-relaxed">
                    {type.desc}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}